import React from "react";
import { Data } from "../../../../../context/OperadorCaixaContext";
import { formatMoney } from "../../../../../utils/formatMoney";
import { Loader } from "../../../../generics/loader";

interface ListInfosProps {
  data: Data | null;
}

export default function ListInfos({ data }: ListInfosProps) {
  return (
    <div className="mt-2 flex w-[100%] space-x-4">
      {!data ? (
        <div className="flex w-[100%] items-center justify-center rounded-lg border p-4">
          <Loader />
        </div>
      ) : (
        <>
          <div className="w-[100%] rounded-lg border p-4">
            <h1 className="text-2xl font-semibold">{data.a_cobrar}</h1>
            <p className="mt-2 font-semibold text-slate-400">
              Fila loja
            </p>
          </div>

          <div className="w-[100%] rounded-lg border p-4">
            <h1 className="text-2xl font-semibold">{data.contratos}</h1>
            <p className="mt-2 font-semibold text-slate-400">Contratos</p>
          </div>

          <div className="w-[100%] rounded-lg border p-4">
            <h1 className="text-2xl font-semibold">
              {formatMoney(data.valor_vencido)}
            </h1>
            <p className="mt-2 font-semibold text-slate-400">Valor vencido</p>
          </div>

          <div className="w-[100%] rounded-lg border p-4">
            <h1 className="text-2xl font-semibold">
              {formatMoney(data.valor_a_vencer)}
            </h1>
            <p className="mt-2 font-semibold text-slate-400">Valor a vencer</p>
          </div>

          {/* Tirar na hora de subir */}
          {/* {formatMoney(data.valor_a_vencer)} */}
          {/* <div className="w-[100%] rounded-lg border p-4 bg-blue-50">
            <h1 className="text-2xl font-semibold">
         
              25
            </h1>
            <p className="mt-2 font-semibold text-slate-400">Acionados</p>
          </div>
          <div className="w-[100%] rounded-lg border p-4 bg-blue-50">
            <h1 className="text-2xl font-semibold">
        
              5
            </h1>
            <p className="mt-2 font-semibold text-slate-400">Agendados</p>
          </div>
          <div className="w-[100%] rounded-lg border p-4 bg-blue-50">
            <h1 className="text-2xl font-semibold">
              {formatMoney(125058.38)}
            </h1>
            <p className="mt-2 font-semibold text-slate-400">Valor Agendado</p>
          </div> */}
        </>
      )}
    </div>
  );
}
